<template>
  <div class="payment-mode">
    <v-row no-gutters>
      <v-col cols="12" md="12" class="pa-0">
        <div class="card card-custom card-compact sub-card">
          <div class="card-header card-header-nobdr pt-0 pl-0 pr-0">
            <div class="card-title">
              <h3 class="card-label">Merchant Payment Mode</h3>
              <span class="sub-title">Showing all merchant payment modes</span>
            </div>
            <div class="header-aside-content">
              <div class="aside-btn" v-if="currentUser.role === 'SUPER_ADMIN' || currentUser.role === 'ADMIN_USER'">
                <v-btn
                  color="primary"
                  @click="addPaymentMode"
                  height="38"
                  width="100"
                >
                  ADD <v-icon right dark> mdi-lock-plus </v-icon></v-btn
                >
              </div>
            </div>
          </div>
          <div class="card-body pt-5">
            <v-expansion-panels v-model="openedPanel">
              <v-expansion-panel
                v-for="(mode, i) in merchantPaymentModes"
                :key="i"
              >
                <v-expansion-panel-header @click="getModeConfig(mode)">
                  {{ mode.name }}
                  <template v-slot:actions> </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                        <div class="mode-status">
                          <div class="mode-switch">
                            <v-switch
                              v-model="mode.status"
                              @change="updateMerchantModeStatus(mode)"
                              :label="`status:`"
                              color="info"
                            ></v-switch>
                            <span class="mode-label">
                              <template v-if="mode.status">
                                Active
                              </template>
                              <template v-else>
                                Inactive
                              </template>
                            </span>
                          </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <template v-if="isValueFilled && (currentUser.role === 'SUPER_ADMIN' || currentUser.role === 'ADMIN_USER')">
                        <div>
                            <v-checkbox
                              v-model="editStatus"
                              @change="editCredentials(mode)"
                              :label="`Edit Payment Credentials`"
                              color="red"
                              density="compact"
                            ></v-checkbox>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                    <form @submit.prevent="!editStatus?createModeWiseCredential(mode):updateModeWiseCredentials(mode)">
                      <template v-if="isKeyValuePaired">

                          <v-row v-for="(item, index) in modeKeyValues" :key="index">
                            <v-col cols="12" md="3">
                              <h6 class="font-weight-medium">{{ item.credentialsValue }}</h6>
                            </v-col>
                            <v-col cols="12" md="7">

                                    <v-text-field
                                      :name="item.credentialsValue"
                                      required
                                      dense
                                      filled
                                      label="Value"
                                      :disabled="!editStatus && item.updated"
                                      v-model="item.value"
                                    ></v-text-field>


                            </v-col>
                          </v-row>

                      </template>
                      <template v-if="!isValueFilled || editStatus">
                        <v-row v-if="currentUser.role === 'SUPER_ADMIN' || currentUser.role === 'ADMIN_USER'">
                          <v-col cols="12" md="3"> </v-col>
                          <v-col cols="12" md="7">
                            <v-btn
                              color="primary"

                              type="submit"
                              >Update</v-btn
                            >
                          </v-col>
                        </v-row>
                      </template>
                    </form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="addPaymentDialog" width="800">
      <add-payment
        :paymentModes="paymentModes"
        @close="closePaymentModeDialog"
        @postPaymentMode="postPaymentMode"
      />
    </v-dialog>
    <v-dialog v-model="confirmStatusDialog" persistent max-width="350">
      <div class="confirmation-box">
        <div class="confirm-dialog">
          <h6>Are You Sure You Want To Update Status?</h6>
        </div>
        <div class="form-popup-footer">
          <v-btn color="grey darken-1" text @click="cancelMerchantModeStatus">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="postMerchantModeStatus">
            Continue
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import Promise from "../../../../../../lib/mixins/ExtendedPromises";
import AdminPayment from "../../../../../../repositories/adminPaymentModeController";
import PaymentCredential from "../../../../../../repositories/merchantPaymentCredentialController";
import AddPayment from "./components/AddPayment.vue";
export default {
  components: { AddPayment },
  name: "PaymentMode",
  mixins: [Promise],
  data() {
    return {
      addPaymentDialog: false,
      paymentModes: [],
      merchantId: "",
      merchantPaymentModes: [],
      confirmStatusDialog: false,
      selectedMode: {},
      modeKeyValues: [],
      selectedPaymentMode: {
        key: "",
        value: ""
      },
      isKeyValuePaired: false,
      currentUser: {},
      openedPanel: null,
      isValueFilled: false,
      editStatus: false
    };
  },
  beforeMount() {
    this.getMerchantId();
    this.currentUser = this.$store.getters.currentUser;
  },
  mounted() {
    this.getMerchantPaymentModes();
    console.log("edit status"+this.editStatus);
  },
  methods: {
    getMerchantId() {
      this.merchantId = this.$route.params.id;
    },
    getPaymentModes() {
      const operation = this.response(AdminPayment.getAllPaymentModes());
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.paymentModes = response.data;
          }
        })
        .catch(err => {
        });
    },
    editCredentials(data) {
      console.log("Edit status = "+this.editStatus);
      console.log("Data = "+data);
    },
    getMerchantPaymentModes() {
      const operation = this.response(
        AdminPayment.findAllMerchcantPaymentMode(this.merchantId)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.merchantPaymentModes = response.data;
            this.getPaymentModes();
            this.merchantPaymentModes.forEach(item => {
              if (item.status === "ACTIVE") {
                item.status = true;
              } else {
                item.status = false;
              }
            });
          }
        })
        .catch(err => {

        });
    },
    updateMerchantModeStatus(mode) {
      this.confirmStatusDialog = true;
      this.selectedMode = mode;
    },
    cancelMerchantModeStatus() {
      if (this.selectedMode.status) {
        this.selectedMode.status = false;
      } else {
        this.selectedMode.status = true;
      }
      this.confirmStatusDialog = false;
    },
    postMerchantModeStatus() {
      let status = "";
      if (this.selectedMode.status) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }
      const operation = this.response(
        AdminPayment.updateMechantPaymentModeStatus(
          this.merchantId,
          this.selectedMode.merchantPaymentModeId,
          status
        )
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.$toasted.show(`${response.data.message}`);
            this.confirmStatusDialog = false;
          }
        })
        .catch(err => {
          this.confirmStatusDialog = false;
        });
    },

    addPaymentMode() {
      this.merchantPaymentModes.forEach(item => {
        this.paymentModes = this.paymentModes.filter(
          modes => modes.code !== item.code
        );
      });

      this.addPaymentDialog = true;
    },
    closePaymentModeDialog() {
      this.addPaymentDialog = false;
    },
    postPaymentMode(modes) {
      let paymentModes = {
        paymentModeId: modes
      };
      const operation = this.response(
        AdminPayment.addMerchantPaymentMode(this.merchantId, paymentModes)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.addPaymentDialog = false;
            this.getMerchantPaymentModes();
          }
        })
        .catch(err => {
          this.addPaymentDialog = false;
        });
    },
    getModeConfig(mode) {
      this.isKeyValuePaired = false;
      const operation = this.response(
        PaymentCredential.getAllCredentialsKeyValues(mode.code)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.modeKeyValues = response.data;
            this.getModeKeyValue(mode);
          }
        })
        .catch(err => {
        });
    },
    getModeKeyValue(mode) {
      const operation = this.response(
        PaymentCredential.getModeCredentialKeyValue(
          this.merchantId,
          mode.merchantPaymentModeId
        )
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            let values = response.data;
            if(values.length > 0) {
              this.isValueFilled = true;
            } else {
              this.isValueFilled = false;
            }
            this.setKeyOfValue(values);
          }
        })
        .catch(err => {
        });
    },
    setKeyOfValue(values) {
      var i = 0;
      let self = this;
      function myLoop() {
        i++;
        for (let x = 0; x < values.length; x++) {
          if (
            self.modeKeyValues[i - 1].credentialsKey == values[x].credentialsKey
          ) {
            self.modeKeyValues[i - 1].updated = true;
            self.modeKeyValues[i - 1].value = values[x].credentialsValue;

          }
        }
        if (i < self.modeKeyValues.length) {

          myLoop();
        } else {
          self.isKeyValuePaired = true;
        }
      }
      myLoop();
    },
    createModeWiseCredential(mode) {



          let payload = {
            requestMap: {}
          };

          this.modeKeyValues.forEach(item => {
            if (item.value !== "" && !item.updated) {
              payload.requestMap[item.credentialsKey] = item.value;
            }
          });

          const operation = this.response(
            PaymentCredential.createPaymentModeWiseCredentials(
              this.merchantId,
              mode.merchantPaymentModeId,
              payload
            )
          );
          operation
            .then(response => {
              if (operation.isFulfilled()) {
                this.$toasted.show(`${response.data.message}`);
                this.getModeKeyValue(mode);
                this.openedPanel = null;

              }
            })
            .catch(err => {
              this.$toasted.show(`${response.data.message}`);
            });

    },
    updateModeWiseCredentials(mode) {
      let payload = {
        paymentCredentials: {

        }
      }
      this.modeKeyValues.forEach(item => {
        if (item.value !== "") {
          payload.paymentCredentials[item.credentialsKey] = item.value;
        }
      });
      const operation = this.response(PaymentCredential.updatePaymentModeWiseCredentials(this.merchantId,mode.merchantPaymentModeId,payload));
      operation.then(response => {
        if (operation.isFulfilled()) {
          this.editStatus = false;
          this.$toasted.show(`${response.data.message}`);
        }
      }).catch( err => {
        this.$toasted.error(`${response.data.message}`)
      });
    }
  }
};
</script>
